document.addEventListener('DOMContentLoaded', function () {

  const packs = document.querySelectorAll('.kc-pack');

  // 🌍 LANGUE
  function getLang() {
    return (document.documentElement.lang || 'en').substring(0, 2);
  }

  // 🌍 LABEL UNITÉ
  function getUnitLabel() {
    const lang = getLang();

const translations = {
  fr: 'unité',
  en: 'unit',
  es: 'unidad',
  de: 'Stück',
  it: 'unità',
  nl: 'stuk',
  pt: 'unidade',
  sv: 'styck'
};

    return translations[lang] || '/ unit';
  }

  // 🌍 TITRE PACK
  function getPackLabel(qty) {
    const lang = getLang();

    const translations = {
      fr: (q) => `Pack de ${q}`,
      en: (q) => `Pack of ${q}`,
      es: (q) => `Pack de ${q}`,
      de: (q) => `${q}er Pack`,
      it: (q) => `Confezione da ${q}`,
      nl: (q) => `Set van ${q}`,
      pt: (q) => `Pacote de ${q}`,
      sv: (q) => `Förpackning med ${q}`
    };

    const fn = translations[lang] || ((q) => `Pack of ${q}`);
    return fn(qty);
  }

  // 💰 FORMAT PRIX
  function formatPrice(price) {
    return (price / 100).toFixed(2).replace('.', ',') + '€';
  }

  // 🔎 VARIANT ID
  function getVariantId() {
    const input = document.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  // ⏳ ATTENTE VARIANT
  function waitForVariantId(callback) {

    let attempts = 0;

    const interval = setInterval(() => {

      const variantId = getVariantId();

      if (variantId) {
        clearInterval(interval);
        callback(variantId);
      }

      attempts++;

      if (attempts > 20) {
        clearInterval(interval);
        console.log("Variant ID introuvable");
      }

    }, 200);
  }

  // 🔥 PRIX SHOPIFY
  async function getVariantPrice(variantId) {
    try {
      const res = await fetch('/variants/' + variantId + '.js');
      const data = await res.json();
      return data.price;
    } catch (e) {
      console.error("Erreur Shopify", e);
      return null;
    }
  }

  // 🔄 UPDATE GLOBAL
  async function updatePackPrices() {

    const variantId = getVariantId();
    if (!variantId) return;

    const basePrice = await getVariantPrice(variantId);
    if (!basePrice) return;

    const unitLabel = getUnitLabel();

    packs.forEach(pack => {

      const qty = parseInt(pack.dataset.qty);
      const discount = parseInt(pack.dataset.discount) || 0;

      const discountedPrice = basePrice * (1 - discount / 100);

      // 💰 PRIX (MODIFIÉ ICI)
      const priceEl = pack.querySelector('.kc-pack-price');
      if (priceEl) {
        priceEl.innerHTML = formatPrice(discountedPrice) + '<br>' + unitLabel;
      }

      // 🏷️ TITRE
      const titleEl = pack.querySelector('.kc-pack-title');
      if (titleEl) {
        titleEl.textContent = getPackLabel(qty);
      }

    });
  }

  // 🚀 INIT
  waitForVariantId(() => {
    updatePackPrices();
  });

  // 🔄 CHANGE VARIANT
  document.addEventListener('change', function () {
    setTimeout(updatePackPrices, 200);
  });

  // 🔁 FALLBACK
  setTimeout(updatePackPrices, 1000);
  setTimeout(updatePackPrices, 2000);

  // 🛒 CLICK PACK
  packs.forEach(pack => {
    pack.addEventListener('click', async function () {

      const qty = parseInt(this.dataset.qty);
      const variantId = getVariantId();

      if (!variantId || !qty) {
        console.error("Variant ID ou quantité invalide");
        return;
      }

      // ACTIVE
      packs.forEach(p => p.classList.remove('active'));
      this.classList.add('active');

      // LOADING
      this.style.opacity = "0.6";
      this.style.pointerEvents = "none";

      try {

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: variantId,
            quantity: qty
          })
        });

        document.dispatchEvent(new CustomEvent('cart:refresh'));

        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('cart:open'));
        }, 200);

      } catch (error) {
        console.error('Erreur panier:', error);
      }

      // RESET
      this.style.opacity = "1";
      this.style.pointerEvents = "auto";

    });
  });

});